<template>
  <div>
    <el-tabs tab-position="left" v-model="activeName" type="card" class="tabs-two" @tab-click="tabClick">
      <el-tab-pane name="1">
        <span slot="label"><i class="el-icon"></i>个人信息</span>
        <personalData></personalData>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label"><i class="el-icon"></i>我的银行卡</span>
        <bankCardManage></bankCardManage>
      </el-tab-pane>
      <el-tab-pane label="风险测评" name="3">
        <span slot="label"><i class="el-icon"></i>风险测评</span>
        <riskAssessment v-if="riskShow" @func="againClick"></riskAssessment>
        <reevaluation v-else @func="reback"></reevaluation>
      </el-tab-pane>
      <el-tab-pane label="密码管理" name="4">
        <span slot="label"><i class="el-icon"></i>密码管理</span>
        <passwordManage v-if="activeName == '4'"></passwordManage>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import personalData from "./personalData/personalData";
import bankCardManage from "./bankCardManage/bankCardManage";
import riskAssessment from "./riskAssessment/riskAssessment";
import reevaluation from "./riskAssessment/reevaluation";
import passwordManage from "./passwordManage/passwordChange";

export default {
  components: {
    personalData,
    bankCardManage,
    riskAssessment,
    reevaluation,
    passwordManage
  },
  created () {
    if (this.$route.params.fundcode == "3") {
      this.activeName = "3"
      this.riskShow = false
    } else {
      this.activeName = this.$route.params.active ? this.$route.params.active : '1'
      this.riskShow = this.$route.params.risk ? false : true
    }

  },
  data () {
    return {
      activeName: '1',
      riskShow: true,
    }
  },
  mounted () {
  },
  methods: {
    againClick (val) {
      this.riskShow = val
    },
    reback (val) {
      this.riskShow = val
    },
    tabClick (tab) {
      if (tab.index == "2") this.riskShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.el-radio-button {
  display: block;
}
</style>

